import { render, staticRenderFns } from "./DeviceRelationList.vue?vue&type=template&id=1f766e23&"
import script from "./DeviceRelationList.vue?vue&type=script&lang=ts&"
export * from "./DeviceRelationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports